import { Module } from '@nu-art/ts-common';
import { apiWithBody } from '@nu-art/thunderstorm-frontend/index';
import { ApiDef_Coralogix } from '@app/coralogix-shared';
export class ModuleFE_Coralogix_Class extends Module {
    v1;
    constructor() {
        super();
        this.v1 = {
            sendTelemetry: apiWithBody(ApiDef_Coralogix.v1.sendTelemetry),
        };
    }
}
export const ModuleFE_Coralogix = new ModuleFE_Coralogix_Class();
//# sourceMappingURL=ModuleFE_Coralogix.js.map